import type {
  BasicSourceMapConsumer,
  IndexedSourceMapConsumer,
  RawIndexMap,
  RawSourceMap,
} from 'source-map'

import { SourceMapConsumer } from 'source-map'

export class SourceMap {
  static #nextId = 0

  consumer: BasicSourceMapConsumer | IndexedSourceMapConsumer
  fileName?: string
  fileNameInline?: string
  id: number
  #mappings: string

  constructor(
    consumer: BasicSourceMapConsumer | IndexedSourceMapConsumer,
    mappings: string,
    fileNameInline?: string,
    fileName?: string,
  ) {
    this.id = SourceMap.#nextId++
    this.consumer = consumer
    this.#mappings = mappings
    this.fileNameInline = fileNameInline
    this.fileName = fileName
  }

  static async create(rawSourceMap: string, sourceMapFileName?: string) {
    let parsed: null | RawIndexMap | RawSourceMap
    try {
      parsed = JSON.parse(rawSourceMap)
    } catch {
      parsed = null
    }

    if (!parsed || !SourceMap.isRawSourceMap(parsed)) {
      return null
    }

    const consumer = await new SourceMapConsumer(rawSourceMap)
    const fileNameInline = parsed.file

    return new SourceMap(consumer, parsed.mappings, fileNameInline, sourceMapFileName)
  }

  static isRawSourceMap(sourceMap: RawIndexMap | RawSourceMap): sourceMap is RawSourceMap {
    return (
      'version' in sourceMap &&
      'sources' in sourceMap &&
      'names' in sourceMap &&
      'mappings' in sourceMap
    )
  }

  isEqual(sourceMap: SourceMap) {
    return (
      this.fileNameInline === sourceMap.fileNameInline && this.#mappings === sourceMap.#mappings
    )
  }
}
